import React, { useEffect } from 'react'

const Demo = () => {
  useEffect(() => {
    // Setăm date dummy în localStorage
    const dummyToken = 'demo_token_' + Date.now()
    const dummyUserData = {
      name: 'Utilizator Demo',
      email: 'demo@alephmedia.ro',
      first_name: 'Demo',
      last_name: 'Utilizator',
      subscription_type: 'premium',
      subscription_status: 'active',
      subscription_expires_at: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString(), // Expiră peste 1 an
      subscription_kind: 'premium'
    }

    // Salvăm datele în localStorage
    localStorage.setItem('authToken', dummyToken)
    localStorage.setItem('userData', JSON.stringify(dummyUserData))
    localStorage.setItem('subscriptionLevel', 'premium')

    // Ștergem flag-ul de guest timeout dacă există
    localStorage.removeItem('v3_guest_timeout')

    // Redirecționăm la homepage v3.0
    // Folosim window.location.replace pentru a evita problema cu refresh-ul
    setTimeout(() => {
      window.location.replace('/v3.0')
    }, 100)
  }, [])

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      flexDirection: 'column',
      gap: '1rem'
    }}>
      <div style={{ fontSize: '1.2rem' }}>Se configurează demo...</div>
      <div style={{ fontSize: '0.9rem', color: '#666' }}>Redirecționare...</div>
    </div>
  )
}

export default Demo

